<script setup>
import ClSlider from '@/components/base/ClSlider.vue'
import {DEFAULT_IMAGE_PATH} from '@/config/filePath.config'
import ClImage from '@/components/base/ClImage.vue'
import { defineProps, ref } from 'vue'
import {useRouter} from 'vue-router'
const slideCourseGroup = ref(null)
const router = useRouter()
const props = defineProps({
  items:{
    type: Object,
    required: true
  }
})
const breakPoints= ref( {
  xs: {
    itemToShow: 1.2,
    itemToSlide: 1
  },
  sm: {
    itemToShow: 2,
    itemToSlide: 2
  },
  md: {
    itemToShow: 2,
    itemToSlide: 1
  },
  lg: {
    itemToShow: 4,
    itemToSlide: 2
  },
  xl: {
    itemToShow: 5,
    itemToSlide: 1
  }
},)
const gotoFilteredCourses = (params)=>{
  router.push(params)
}
</script>

<template>
  <v-row class="my-4 d-flex justify-center flex-wrap">
    <ClSlider  v-if="$vuetify.display.smAndDown" :items="props.items"  ref="slideCourseGroup" hideArrows :break-points="breakPoints" :autoplay="false" class="pr-md-3 w-100">
      <template #item="{ item}">
        <v-col class="d-flex justify-content-center p-0"  cols="12" md="4">
          <div class="flip rounded-lg my-3" >
            <v-dialog width="100%" height="700px" class="ma-0" blur>
              <template v-slot:activator="{ props: activatorProps }">
                <ClImage
                  path="CATEGORY_BANNER"
                  :default-image="DEFAULT_IMAGE_PATH.COURSE_BANNER"
                  :alt="item.link"
                  class="w-100 rounded-xl overflow-hidden"
                  :image="item.main_banner"
                  :aspectRatio="16/9"
                  max-width="500px"
                />
                <v-btn
                  variant="flat"
                  v-bind="activatorProps"
                  border
                  rounded="lg"
                  color="#fff"
                  class="position-absolute"
                  append-icon="$mdiChevronLeftBoxOutline"
                  style="color: #45464F; bottom: 10px; left: 10px">
                  مشاهده جزییات
                </v-btn>
              </template>
              <template v-slot:default="{ isActive }">
                <v-btn
                  @click="isActive.value = false"
                  density="compact"
                  color="text-secondary"
                  class="position-absolute"
                  icon="$close"
                  style="z-index: 10; top: 10px; left: 10px">
                </v-btn>
                <v-card rounded="xl" height="100%">
                  <v-row class="d-flex flex-grow-0" >
                    <v-col cols="12" md="5" class="position-relative">
                      <ClImage
                        path="CATEGORY_BANNER"
                        :default-image="DEFAULT_IMAGE_PATH.COURSE_BANNER"
                        :alt="item.link"
                        class="w-100 rounded-xl overflow-hidden"
                        :image="item.main_banner"
                        :aspectRatio="16/9"
                      />
                      <div style="backdrop-filter: blur(50px); bottom: 0" class="w-100 position-absolute left-0 d-flex justify-center py-4" >
                        <v-btn
                          text="مشاهده لیست دوره‌ها"
                          variant="outlined"
                          class="px-5"
                          color="#155EEF"
                          rounded="lg"
                          style="background: #EFF8FF;"
                          append-icon="$mdiChevronLeftBoxOutline"
                          border="#155EEF"
                          @click="gotoFilteredCourses(item.link)"
                        ></v-btn>
                      </div>

                    </v-col>
                    <v-col cols="12" md="7" class="d-flex flex-column justify-start mt-14">
                      <p class="mx-6 text-secondary" v-html="item.content"></p>
                      <div class="w-100 border-bottom text-secondary mx-6"></div>
                      <div class="d-flex text-secondary mx-6 mt-5">
                        <v-icon icon="$mdiCalendarClock" size="small" class="ml-5"></v-icon>
                        <span>زمان شروع: {{item.start_date}}</span>
                      </div>
                      <v-btn
                        v-if="!$vuetify.display.mdAndDown"
                        text="مشاهده لیست دوره‌ها"
                        variant="outlined"
                        class="px-5"
                        :class="[$vuetify.display.mdAndDown?'':'align-self-end']"
                        color="#155EEF"
                        base-color="#EFF8FF"
                        append-icon="$mdiChevronLeftBoxOutline"
                        border="#155EEF"
                        @click="gotoFilteredCourses(item.link)"
                      ></v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </template>
            </v-dialog>
          </div>
        </v-col>
      </template>
    </ClSlider>
    <template v-if="!$vuetify.display.smAndDown && items.length>0">
      <v-col  v-for="item in items" :key="item.id" class="d-flex justify-content-center"  cols="12" lg="3" md="6">
        <div class="flip rounded-lg my-3" :class="{'max__height__card': !$vuetify.display.xlAndUp}">
            <v-dialog width="1000px" class="ma-0">
              <template v-slot:activator="{ props: activatorProps }">
                <ClImage
                  path="CATEGORY_BANNER"
                  :default-image="DEFAULT_IMAGE_PATH.COURSE_BANNER"
                  :alt="item.link"
                  class="w-100 rounded-xl overflow-hidden"
                  :image="item.main_banner"
                  :aspectRatio="16/9"
                  max-width="500px"
                />
                <v-btn
                  variant="flat"
                  v-bind="activatorProps"
                  border
                  rounded="lg"
                  color="#fff"
                  class="position-absolute"
                  append-icon="$mdiChevronLeftBoxOutline"
                  style="color: #45464F; bottom: 15px; left: 15px">
                  مشاهده جزییات
                </v-btn>
              </template>
              <template v-slot:default="">
                <v-card rounded="xl">
                  <v-row class="ma-5">
                    <v-col cols="12" md="5">
                      <ClImage
                        path="CATEGORY_BANNER"
                        :default-image="DEFAULT_IMAGE_PATH.COURSE_BANNER"
                        :alt="item.link"
                        class="w-100 rounded-xl overflow-hidden"
                        :image="item.main_banner"
                        :aspectRatio="16/9"
                        max-width="500px"
                      />
                      <h6 class="text-secondary mt-6 mb-3">{{item.title}}</h6>
                      <div class="w-100 border-bottom text-secondary"></div>
                      <div class="d-flex text-secondary mt-5">
                        <v-icon icon="$mdiCalendarClock" size="small" class="ml-5"></v-icon>
                        <span>زمان شروع: {{item.start_date}}</span>
                      </div>
                    </v-col>
                    <v-col cols="12" md="7" class="d-flex flex-column justify-space-between">
                      <p v-html="item.content"></p>
                      <v-btn
                        text="مشاهده لیست دوره ها"
                        variant="outlined"
                        class="px-5 align-self-end"
                        color="#155EEF"
                        rounded="lg"
                        style="background: #EFF8FF;"
                        append-icon="$mdiChevronLeftBoxOutline"
                        border="#155EEF"
                        @click="gotoFilteredCourses(item.link)"
                      ></v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </template>
            </v-dialog>
          </div>
      </v-col>
    </template>
  </v-row>
</template>


<style lang="scss">
.v-dialog > .v-overlay__content{
  max-width: 100%;

}
.v-dialog > .v-overlay__content > .v-card{
  overflow-y: hidden;
}
.flip {
  width: 100%;
  display: flex;
  justify-content: center;
  max-width: 490px;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.item {
  width: 70px;
  border-radius: 40px;
  transition: width .5s ease-out ;
}
.max__height__card{
  max-height: 211px;
}
</style>
